import { Icon } from './common-class';

export class CommercialClass {
  idCommercial: number | null = null;
  idCommercialOwner: number | null = null;
  idUser: number | null = null;
  Photo: Blob | null = null;
  Name: string = '';
  Email: string = '';
  NIF: string = '';
  CustomerTaxID: number | null = null;
  Office: string = '';
  Birthdate: Date | null = null;
  idSexTypes: number | null = null;
  Contact: string = '';
  PhotoURL: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Default: boolean = false;
  idAGEAS: string = '';
  idTranquilidade: string = '';
  UUID: string = '';
  UUIDLastChange: string = '';
}

// export class Photo {
//     type: string = '';
//     data: number[];
//     UUIDLastChange: string = '';
// }

export class CommercialTotalProductsClass {
  idCommercial: number | null = null;
  idProduct: number | null = null;
  name: string = '';
  value: number | null = null;
  UUIDLastChange: string = '';
}

export class CommercialsAreaLayoutResumeClass {
  idCommonLayoutCards: number | null = null;
  Description: string = '';
  OutsideCardMinWidth: string = '';
  OutsideCardMaxWidth: string = '';
  OutsideCardMinHeight: string = '';
  OutsideCardMaxHeight: string = '';
  OutsideCardMargin: string = '';
  OutsideCardPadding: string = '';
  OutsideCardfxFlex: string = '';
  OutsideCardfxFlexxl: string = '';
  OutsideCardfxFlexlg: string = '';
  OutsideCardfxFlexgtmd: string = '';
  OutsideCardfxFlexgtsm: string = '';
  OutsideCardfxFlexmd: string = '';
  OutsideCardfxFlexsm: string = '';
  OutsideCardfxFlexxs: string = '';
  InsideCardfxFlex: string = '';
  InsideCardfxFlexxl: string = '';
  InsideCardfxFlexlg: string = '';
  InsideCardfxFlexgtmd: string = '';
  IntsideCardfxFlexgtsm: string = '';
  InsideCardfxFlexmd: string = '';
  InsideCardfxFlexsm: string = '';
  IntsideCardfxFlexxs: string = '';
  InsideCardMinWidth: string = '';
  InsideCardMaxWidth: string = '';
  IntsideCardMinHeight: string = '';
  InsideCardMaxHeight: string = '';
  InsideCardMargin: string = '';
  InsideCardPadding: string = '';
  idCommercialAreaLayoutResume: number | null = null;
  idCommercialsAreaCommercialResume: number | null = null;
  DescriptionResume: string = '';
  Background: string = '';
  Color: string = '';
  Order: number | null = null;
  LineTop: number | null = null;
}

export class LayoutResumeHTMLClass {
  NTOP: number | null = null;
  NLEFT: number | null = null;
  NRIGHT: number | null = null;
  HTML: string = '';
}

export class ResumeCustomerProductsClass {
  idProduct: number | null = null;
  idCompanie: number | null = null;
  Name: string = '';
  IconMinWidth: number | null = null;
  IconMinHeight: number | null = null;
  TextColor: string = '';
  BackgroundColor: string = '';
  Icon: Icon | null = null;
  N: number | null = null;
}
